// soft encode in runtime
export const ACCESS_TOKEN_KEY = 'access_token';
export const USER_INFO_KEY = 'user_info';
